// eslint-disable-next-line no-restricted-imports
import { LegalClientSourcesOfIncomeFragment } from 'api/generated/graphql';
import {
  LegalClientSourcesOfIncomeSourceType,
  LegalClientSourcesOfIncomeEntity,
  LegalClientSourcesOfIncomeFinancialSourceType,
} from 'api/types/entity';
import { lodash } from 'helpers';

import { parseFileEntity } from '../../helpers';

export const parseLegalClientSourcesOfIncomeEntity = (
  data: LegalClientSourcesOfIncomeFragment
): LegalClientSourcesOfIncomeEntity => {
  const res: LegalClientSourcesOfIncomeEntity = {
    incomeSources: lodash.compact(
      data.incomeSources.map(
        (v) => v && LegalClientSourcesOfIncomeSourceType[v]
      )
    ),
    financialSources: lodash.compact(
      data.financialSources.map(
        (v) => v && LegalClientSourcesOfIncomeFinancialSourceType[v]
      )
    ),
    otherIncomeSource: data.otherIncomeSource || undefined,
    otherFinancialSource: data.otherFinancialSource || undefined,
    files: lodash.compact(data.confirmationFiles).map(parseFileEntity),
  };

  return res;
};
